import styled from "styled-components";

export const Input = styled.input`
	color: #637381;
	border-radius: 7px;
	border: 1px solid #dfe4ea;
	padding: 8px 15px;
	height: 38px;
	font-size: 0.875rem;
	overflow: hidden;
	text-overflow: ellipsis;
	&::placeholder {
		-webkit-appearance: none !important;
		appearance: none !important;
		font-size: 0.875rem !important;
		color: #bcbcbc !important;
		opacity: 1 !important;
	}
	&:hover {
		border-color: #bcbcbc !important;
		outline: none;
	}

	&:focus {
		border-color: #bcbcbc !important;
		outline: none;
	}

	&:focus-visible {
		border-color: #bcbcbc !important;
		outline: none;
	}
	box-shadow: none !important;

	&:disabled {
		-webkit-appearance: none !important;
		appearance: none !important;
		background-color: #f3f3f3 !important;
		background-image: linear-gradient(to right, #f3f3f3, #f3f3f3) !important;
		color: rgb(99, 115, 129) !important;
		-webkit-text-fill-color: rgb(99, 115, 129) !important;
		opacity: 1 !important;
		pointer-events: none;
	}
`;

export const TextArea = styled.textarea<{}>`
	padding: 0.5rem 0.875rem;
	font-size: 0.8125rem;
	font-weight: 400;
	line-height: 1.47;
	background-color: rgb(255, 255, 255);
	border: 0;
	border-radius: 7px;
	border: 1px solid #dfe4ea;
	min-width: 0;
	width: calc(100%);
	min-height: 120px;
	&:focus {
		outline: none;
		border-color: #dfe4ea;
	}
	&:disabled {
		background-color: #f3f3f3;
	}
	::placeholder {
		font-size: 1rem; /* Adjusted font size for placeholder */
	}
`;
